import React from "react";
import ReactDOM from "react-dom";
import "./assets/theme/index.css";
import 'react-notifications-component/dist/theme.css'
import initTelegramMock from './utils/telegramMock';
import App from './App';
import initIframeProtection from './utils/iframeProtection';

// Мок Telegram WebApp для локальной разработки (только при REACT_APP_DEV_MODE=true)
initTelegramMock();

// Инициализируем защиту от нежелательных iframe
initIframeProtection();

ReactDOM.render(<App/>, document.getElementById('root'));
